import { styled } from '@mui/material/styles';
import { ReactElement } from 'react';

type CustomRadioCheckboxProps = { value: boolean; onChange: () => void; testId?: string };

const StyledRadio = styled('input')(({ theme }) => ({
  // @ts-ignore
  accentColor: theme?.palette?.grey?.bt_def_grey_reg,
  width: '16px',
  height: '16px',
  margin: '0px',
  cursor: 'pointer',
}));

const CustomRadioCheckbox = ({ value, onChange, testId }: CustomRadioCheckboxProps): ReactElement => (
  <StyledRadio type="radio" checked={value} onClick={onChange} data-testId={testId} />
);

export default CustomRadioCheckbox;
